import api from '../utils/api';

// Fetch all grade mark records
export const getAllGradeMarks = async (headers) => {
  try {
    const response = await api.get('/api/grade-marks',  headers );
    return response.data;
  } catch (error) {
    console.error('Error fetching all grade marks:', error.response ? error.response.data : error.message);
    throw error;
  }
};

// Fetch a specific grade mark record by ID
export const getGradeMarkById = async (id, headers) => {
  try {
    const response = await api.get(`/api/grade-marks/${id}`,  headers );
    return response.data;
  } catch (error) {
    console.error(`Error fetching grade mark with ID ${id}:`, error.response ? error.response.data : error.message);
    throw error;
  }
};

// Create a new grade mark record
export const createGradeMark = async (gradeMarkData, headers) => {
  try {
    const response = await api.post('/api/grade-marks', gradeMarkData,  headers );
    return response.data;
  } catch (error) {
    console.error('Error creating grade mark:', error.response ? error.response.data : error.message);
    throw error;
  }
};

// Update an existing grade mark record
export const updateGradeMark = async (id, gradeMarkData, headers) => {
  try {
    const response = await api.put(`/api/grade-marks/${id}`, gradeMarkData,  headers );
    return response.data;
  } catch (error) {
    console.error(`Error updating grade mark with ID ${id}:`, error.response ? error.response.data : error.message);
    throw error;
  }
};

// Delete a grade mark record
export const deleteGradeMark = async (id, headers) => {
  try {
    const response = await api.delete(`/api/grade-marks/${id}`,  headers );
    return response.data;
  } catch (error) {
    console.error(`Error deleting grade mark with ID ${id}:`, error.response ? error.response.data : error.message);
    throw error;
  }
};
